import { FormGroup } from '@angular/forms';
import { Component, Input, OnInit } from '@angular/core';
import { Document } from '../model/document';
import { TemplateAttribute } from '../model/template-attribute';
import { TemplateAttributeType } from '../model/template-attribute-type.enum';
import { MatSelectChange as MatSelectChange } from '@angular/material/select';
import { TemplateAttributeMode } from '../model/template-attribute-mode.enum';
import { SelectDefinition } from '../model/select-definition';
import { TranslationService } from '@sdbn/common';

@Component({
    selector: 'app-template-attribute',
    templateUrl: './attribute.component.html',
    styleUrls: ['./attribute.component.scss'],
    standalone: false
})
export class AttributeComponent implements OnInit {

  _templateAttribute: TemplateAttribute;
  _document: Document;

  selectDefinition: SelectDefinition;

  @Input() set templateAttribute(templateAttribute: TemplateAttribute) {
    this._templateAttribute = templateAttribute;
    this.initSelectDefinition();
  }
  @Input() set document(document: Document) {
    this._document = document;
    this.initSelectDefinition();
  }

  @Input() form: FormGroup;

  @Input() metaData: any;

  attributeType = TemplateAttributeType;
  attributeMode = TemplateAttributeMode;

  constructor(public translationService: TranslationService) { }

  ngOnInit() {
  }

  public selectionChanged(select: MatSelectChange) {

    const definition = this.selectDefinition.options.find(se => se.value === select.value);
    if (definition != null) {
      for (const entryValue of definition.attributeValues) {
        const ctrl = this.form.controls[entryValue.key];
        if (ctrl != null) {
          ctrl.setValue(entryValue.value);
        }
      }
    }
  }

  private initSelectDefinition() {
    if (this._document != null && this._templateAttribute != null && this._templateAttribute.selectDefinitionUuid != null) {
      this.selectDefinition = this._document.template.selectDefinitions.find(
        sd => sd.uuid === this._templateAttribute.selectDefinitionUuid
      );
    }
  }
}
